import { objectSpread2 as _objectSpread2, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { algoliaSearchClients } from '../../util/algolia.js';
import { transformFromDiscoveryToSearch } from './transformFromDiscoveryToSearch.js';

var querySet = {};
var requestCache = {};
var trackSearchResults = function trackSearchResults(resultSet, resultType) {
  if (window.tracking) {
    window.tracking.track('Search Index Result Counts', {
      query: resultSet.query,
      totalResultCount: resultSet.nbHits,
      index: resultSet.index,
      location: window.location.pathname,
      resultType: resultType
    });
  }
};
var search = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(query, pluginId, logger) {
    var allRequests, allQueryKeys, data, mergedDataArray;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          allRequests = [];
          allQueryKeys = [];
          Object.keys(querySet).map(function (application) {
            var queryKeys = Object.keys(querySet[application]);
            if (!requestCache[application]) {
              requestCache[application] = {};
            }
            var request = requestCache[application][query];
            if (!request) {
              request = algoliaSearchClients[application].search(queryKeys.map(function (key) {
                return _objectSpread2(_objectSpread2({}, querySet[application][key]), {}, {
                  query: query
                });
              }))["catch"](function (err) {
                logger === null || logger === void 0 || logger.error('Error fetching results from algolia', {
                  contextData: {
                    source: 'omnisearch',
                    error: err.message,
                    query: query,
                    algoliaApplication: application,
                    requestConfig: querySet[application]
                  }
                });
                return {
                  results: []
                };
              });
              requestCache[application][query] = request;
            }
            allRequests.push(request);
            allQueryKeys.push.apply(allQueryKeys, queryKeys);
          });
          _context.next = 5;
          return Promise.all(allRequests);
        case 5:
          data = _context.sent;
          mergedDataArray = data.reduce(function (acc, currentObj) {
            return acc.concat(currentObj.results);
          }, []);
          return _context.abrupt("return", mergedDataArray[allQueryKeys.indexOf(pluginId)]);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function search(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var getSearchParametersBuilder = function getSearchParametersBuilder(locale) {
  return function (userAbTests) {
    var defaultSearchParameters = {
      clickAnalytics: true,
      getRankingInfo: true,
      filters: 'searchFields.publiclyAvailable:true',
      restrictSearchableAttributes: ['title', 'description', 'searchFields.tags', 'attributeFacets.ancestors', 'searchFields.aka', 'searchFields.descriptor', 'searchFields.useCase', 'searchFields.altSpelling', 'pricingProductId', 'searchFields.galleryCategories'] //quirks of how Algolia allows querying on specific fields means we default to limiting searched fields
    };
    var userSearchParameters = defaultSearchParameters;

    // Will only affect indexes that also have turned on ai-reranking
    userSearchParameters.enableReRanking = true;

    //add if checks for additional tests here
    return userSearchParameters;
  };
};
var defaultGetSearchParameters = getSearchParametersBuilder();
var AlgoliaIndexResultPlugin = function AlgoliaIndexResultPlugin(id, indexName, taxonomyId) {
  var getSearchParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultGetSearchParameters;
  var hitsPerPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;
  var resultType = arguments.length > 5 ? arguments[5] : undefined;
  var application = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'prod';
  var registerPlugin = function registerPlugin(pluginId, appliedFacetFilters, _sortStrategy, userAbTests) {
    var paginationNumber = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    if (!querySet[application]) {
      querySet[application] = {};
    }
    querySet[application][pluginId] = {
      indexName: indexName,
      params: _objectSpread2(_objectSpread2({}, getSearchParams(userAbTests)), {}, {
        facetFilters: Object.keys(appliedFacetFilters || {}).map(function (key) {
          return Array.from(appliedFacetFilters[key]).map(function (value) {
            return "".concat(key, ":").concat(value);
          });
        }),
        facets: ['*'],
        page: paginationNumber,
        hitsPerPage: hitsPerPage
      })
    }, requestCache = {};
  };
  var resultsPromise = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(pluginId, query, filters, sort, userAbTests, logger) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", search(query, pluginId, logger).then(function (data) {
              var _data$appliedRules;
              if (indexName.includes('Discovery')) {
                var transformedHits = transformFromDiscoveryToSearch(data.hits);
                data.hits = transformedHits;
              }
              trackSearchResults(data, resultType);
              var results = data.hits.map(function (hit, searchPosition) {
                var _hit$showInAbTests2;
                var hideInTests = userAbTests === null || userAbTests === void 0 ? void 0 : userAbTests.filter(function (test) {
                  var _hit$hideInAbTests, _hit$showInAbTests;
                  return ((_hit$hideInAbTests = hit.hideInAbTests) === null || _hit$hideInAbTests === void 0 ? void 0 : _hit$hideInAbTests.includes("".concat(test.Experiment, "-").concat(test.Variation))) || ((_hit$showInAbTests = hit.showInAbTests) === null || _hit$showInAbTests === void 0 ? void 0 : _hit$showInAbTests.some(function (testKey) {
                    return testKey.startsWith(test.Experiment) && testKey !== "".concat(test.Experiment, "-").concat(test.Variation);
                  }));
                });
                var hiddenFromLackOfTests = hit.showInAbTests ? !((_hit$showInAbTests2 = hit.showInAbTests) !== null && _hit$showInAbTests2 !== void 0 && _hit$showInAbTests2.some(function (testKey) {
                  return testKey === 'none' || (userAbTests === null || userAbTests === void 0 ? void 0 : userAbTests.some(function (test) {
                    return testKey.startsWith(test.Experiment);
                  }));
                })) : false;
                var algoliaResult = {
                  indexName: indexName,
                  searchPosition: 1 + searchPosition,
                  //algolia specifically uses 1-indexed positions
                  queryId: data.queryID,
                  shouldHide: (hideInTests === null || hideInTests === void 0 ? void 0 : hideInTests.length) || hiddenFromLackOfTests,
                  hideInTests: hideInTests,
                  rankingInfo: hit._rankingInfo
                };
                return _objectSpread2(_objectSpread2({}, hit), {}, {
                  id: hit.objectID,
                  algoliaResult: algoliaResult,
                  resultType: resultType,
                  resultSource: indexName
                });
              });
              return {
                results: results,
                availableFacets: data.facets,
                totalCount: data.nbHits,
                sectionTrackingDetails: {
                  rules: (_data$appliedRules = data.appliedRules) === null || _data$appliedRules === void 0 ? void 0 : _data$appliedRules.map(function (rule) {
                    return "".concat(indexName, ":").concat(rule.objectID);
                  })
                }
              };
            })["catch"](function (err) {
              logger === null || logger === void 0 || logger.error('Error proccessing results from algolia', {
                contextData: {
                  source: 'omnisearch',
                  error: err.message,
                  pluginId: pluginId,
                  query: query,
                  filters: filters,
                  sort: sort,
                  userAbTests: userAbTests
                }
              });
              return {
                results: [],
                availableFacets: {},
                totalCount: 0
              };
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function resultsPromise(_x4, _x5, _x6, _x7, _x8, _x9) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    pluginId: id,
    taxonomyId: taxonomyId,
    resultsPromise: resultsPromise,
    registerPlugin: registerPlugin
  };
};

export { AlgoliaIndexResultPlugin, getSearchParametersBuilder };
//# sourceMappingURL=AlgoliaPlugin.js.map
